import { 
  LayoutDashboard, 
  PackageCheck, 
  SearchCheck, 
  ShieldCheck, 
  Warehouse, 
  FileText, 
  Truck, 
  ListOrdered, 
  Users, 
  Settings,
  Plug,
  LogOut
} from "lucide-react";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { NavLink } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";

interface VaultPartnerSidebarProps {
  partnerName?: string;
}

const menuItems = [
  { id: "dashboard", title: "Dashboard", icon: LayoutDashboard, path: "/vault-partner/dashboard" },
  { id: "intake", title: "Intake Queue", icon: PackageCheck, path: "/vault-partner/intake" },
  { id: "inspection", title: "Inspection", icon: SearchCheck, path: "/vault-partner/inspection" },
  { id: "authentication", title: "Authentication", icon: ShieldCheck, path: "/vault-partner/authentication" },
  { id: "inventory", title: "Storage / Vault Inventory", icon: Warehouse, path: "/vault-partner/inventory" },
  { id: "certificates", title: "Certificate Issuance", icon: FileText, path: "/vault-partner/certificates" },
  { id: "fulfillment", title: "Outbound Fulfillment", icon: Truck, path: "/vault-partner/fulfillment" },
  { id: "chain-of-custody", title: "Chain-of-Custody Logs", icon: ListOrdered, path: "/vault-partner/chain-of-custody" },
  { id: "team", title: "Team Access", icon: Users, path: "/vault-partner/team" },
  { id: "integrations", title: "Integrations", icon: Plug, path: "/vault-partner/integrations" },
  { id: "settings", title: "Settings", icon: Settings, path: "/vault-partner/settings" },
];

export function VaultPartnerSidebar({ partnerName }: VaultPartnerSidebarProps) {
  const { open } = useSidebar();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate("/auth");
  };

  return (
    <Sidebar className={open ? "w-60" : "w-14"}>
      <div className="p-4 border-b flex items-center gap-2">
        <ShieldCheck className="h-5 w-5 text-primary" />
        {open && (
          <div className="flex-1">
            <h2 className="font-semibold text-sm">{partnerName || "Vault Partner"}</h2>
            <p className="text-xs text-muted-foreground">Partner Portal</p>
          </div>
        )}
      </div>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Vault Partner Portal</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.id}>
                  <SidebarMenuButton asChild>
                    <NavLink
                      to={item.path}
                      className={({ isActive }) =>
                        isActive
                          ? "bg-muted text-primary font-medium"
                          : "hover:bg-muted/50"
                      }
                    >
                      <item.icon className="h-4 w-4" />
                      {open && <span>{item.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
              
              {/* Sign Out */}
              <SidebarMenuItem>
                <SidebarMenuButton onClick={handleSignOut} className="hover:bg-muted/50 text-destructive">
                  <LogOut className="h-4 w-4" />
                  {open && <span>Sign Out</span>}
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
